export default __webpack_public_path__ + "static/certificateGen-bafc21ae6313609c9d6dfd61ad0a6c60.gif";